import { render } from "./TemplateModalParkingGroup.vue?vue&type=template&id=7f2cb563&ts=true"
import script from "./TemplateModalParkingGroup.vue?vue&type=script&lang=ts"
export * from "./TemplateModalParkingGroup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__